module.exports = __webpack_public_path__ + "static/intro-a0e513e7bf00362b30dac62e950ad4dc.mp4";